var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle43C = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 43 55",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M31.001 1a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-11v30h10a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-29a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h30Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  fillRule: "evenodd",
  d: "M38.501 10.2c-4.341 0-8.527 1.765-11.63 4.942C23.765 18.322 22 22.658 22 27.2c0 4.543 1.764 8.878 4.87 12.059C29.974 42.435 34.16 44.2 38.5 44.2a4.5 4.5 0 1 1 0 9c-6.798 0-13.295-2.765-18.068-7.653C15.663 40.664 13 34.062 13 27.2c0-6.862 2.662-13.463 7.432-18.347C25.206 3.966 31.703 1.2 38.5 1.2a4.5 4.5 0 1 1 0 9Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M19.87 8.147A27 27 0 0 1 39 .2a1 1 0 1 1 0 2 25 25 0 1 0 0 50 1 1 0 1 1 0 2A27 27 0 0 1 19.87 8.147Z",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M41.655 16c.743 0 1.346.947 1.346 2.115v17.77c0 1.168-.603 2.115-1.346 2.115H30.347c-.743 0-1.346-.947-1.346-2.115v-17.77c0-1.168.603-2.115 1.346-2.115h11.308Z"
})));
SvgRectangle43C.viewBox = '0 0 43 55';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle43C);
export default ForwardRef;